import { Component, OnInit } from '@angular/core';
import { BookstoreService } from 'src/app/services/bookstore/bookstore.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-issue-item-day-wise-report',
  templateUrl: './issue-item-day-wise-report.component.html',
  styleUrls: ['./issue-item-day-wise-report.component.css']
})
export class IssueItemDayWiseReportComponent implements OnInit {

  IssueItemDayWiseReportList:any=[];
  TotalAmount:any;
  TotalQty:any;
  ItemCategoryList:any=[];

  constructor(private bookstoreservice: BookstoreService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    IssueItemModel = {
      ItemCategoryID: 0,
      ItemCode: '',
      ItemName:'',
      FromDate: new Date(),
      ToDate: new Date(),
      OrderBy: 'FirstName',
      Order: 'ASC',
  }

  
  GetIssueItemDayWiseReport() {
    this.spinnerService.show();
    this.IssueItemDayWiseReportList=[];
    this.bookstoreservice.GetIssueItemDayWiseReport(JSON.stringify(this.IssueItemModel)).subscribe((data: any) => {
      this.spinnerService.hide();
        this.IssueItemDayWiseReportList = data.IssueItemDayWiseReportList;
        var TotalAmount = 0;
        var TotalQty = 0;
        if (this.IssueItemDayWiseReportList != null) {
            for (var i = 0; i < this.IssueItemDayWiseReportList.length; i++) {
                TotalAmount = TotalAmount + this.IssueItemDayWiseReportList[i].UnitPrice;
                TotalQty = TotalQty + this.IssueItemDayWiseReportList[i].Qty;
            }
        }
        this.TotalAmount = TotalAmount;
        this.TotalQty = TotalQty;
    });
};



Clear() {
    this.IssueItemDayWiseReportList = [];
    this.IssueItemModel.ItemCategoryID = 0;
    this.IssueItemModel.ItemName = '';
    this.IssueItemModel.ItemCode = '';
    this.IssueItemModel.FromDate = new Date();
    this.IssueItemModel.ToDate = new Date();
   
}
  ngOnInit() {
    this.GetItemCategory();
  }

  GetItemCategory() {
    var item = {
        ItemId: 2
    }
    this.spinnerService.show();
    this.lookupservice.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe((data: any) => {
        this.ItemCategoryList = data.LookupItems;
        this.spinnerService.hide();
    });
};
  // Download

XLSDownload() {
  this.spinnerService.show();
  if (this.IssueItemDayWiseReportList != null) {
      this.JSONToCsvConverterList(this.IssueItemDayWiseReportList, 'Item_Issued_List', true);
  }
  this.spinnerService.hide();
};

JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
  var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
  var CSV = '';
  if (ShowLabel) {
      var row = "";
      row += 'Sr. No.' + ',';
      row += 'Name' + ',';
      row += 'Class' + ',';
      row += 'Section' + ',';
      row += 'Item Category' + ',';
      row += 'Item Code' + ',';
      row += 'Item Name' + ',';
      row += 'Qty' + ',';
      row += 'Amount' + ',';
      row += 'Date' + ',';
      row = row.slice(0, -1);
      CSV += row + '\r\n';
  }
  for (var i = 0; i < arrayData.length; i++) {
      var sno = i + 1;
      var row = "";
      row += '"' + sno + '",';
      if (arrayData[i].Name != null) {
          row += '"' + arrayData[i].Name + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].ClassName != null) {
          row += '"' + arrayData[i].ClassName + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].SectionName != null) {
          row += '"' + arrayData[i].SectionName + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].ItemCategory != null) {
          row += '"' + arrayData[i].ItemCategory + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].ItemCode != null) {
          row += '"' + arrayData[i].ItemCode + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].ItemName != null) {
          row += '"' + arrayData[i].ItemName + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].Qty != null) {
          row += '"' + arrayData[i].Qty + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].UnitPrice != null) {
          row += '"' + arrayData[i].UnitPrice + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      if (arrayData[i].CreatedOn != null) {
          row += '"' + moment(arrayData[i].CreatedOn).format('DD-MMM-YYYY') + '",';
      }
      else {
          row += '"' + '' + '",';
      }
      row.slice(0, row.length - 1);
      CSV += row + '\r\n';
  }
  var row1 = "";
  row1 += ' ' + ',';
  row1 += ' ' + ',';
  row1 += ' ' + ',';
  row1 += ' ' + ',';
  row1 += ' ' + ',';
  row1 += ' ' + ',';
  row1 += 'Total' + ',';
  row1 += '"' + this.TotalQty + '",';
  row1 += '"' + this.TotalAmount + '",';
 
  CSV += row1 + '\r\n';
  if (CSV == '') {
      alert('Invalid Data');
      return;
  }
  var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');
  var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
  var csvURL = window.URL.createObjectURL(csvData);
  var tempLink = document.createElement('a');
  tempLink.href = csvURL;
  tempLink.setAttribute('download', FileName + '.csv');
  tempLink.click();
}


}
